import Call from '../Call';
import { objToQs } from '../Utils';



const Notifications = {
    get(tagid, isArchive) {
        return Call(`notifications/single/${tagid}${isArchive ? '/archive' : ''}`);
    },

    getPage(page, filters, isArchive) {
        return Call(`notifications/${page}${isArchive ? '/archive' : ''}?${objToQs(filters)}`);
    },

    send(data) {
        return fetch(`http://push-signals.online/new/private/api/send`,{
            method: 'POST',
            headers: {
                "Content-type": "application/json"
            },
            body: JSON.stringify(data)
        })
        .then(response => {
            return response.json();
        });
    }
}

export default Notifications;


// WEBPACK FOOTER //
// ./src/services/API/components/Notifications.js